// @ts-check

import { api } from '@/api'
import { useMemoize } from '@vueuse/core'

/**
 * @type {import('@vueuse/core').UseMemoizeReturn<Promise<Industries>, [LocalizedPayload]>}
 */
export const getIndustries = useMemoize(async (params = {}) => {
  const res = await api.get('industries', {
    params
  })
  return res.data
})

/**
 * @type {import('@vueuse/core').UseMemoizeReturn<Promise<IndustryGroups>, [LocalizedPayload]>}
 */
export const getIndustryGroups = useMemoize(async (params = {}) => {
  const res = await api.get('industries/groups', {
    params
  })
  return res.data
})

/**
 * Get AI-suggested industries based on business description
 * @param {string} description - Business description (min 10, max 1000 chars)
 * @returns {Promise<Industries>}
 */
export const suggestIndustries = async (description) => {
  const res = await api.post('industries/suggest', {
    description
  })
  return res.data
}
